<template>
  <div class="range-inline">
    <span v-if="label" class="range-label">{{ label }}</span>
    <div class="range-container">
      <a-input-number
        v-model:value="minValue"
        :placeholder="minPlaceholder"
        :min="min"
        :max="max"
        :bordered="false"
        class="range-input left"
        :class="{ 'range-input-wrap': showHandleWrap }"
      />
      <span class="divider">～</span>
      <a-input-number
        v-model:value="maxValue"
        :placeholder="maxPlaceholder"
        :min="min"
        :max="max"
        :bordered="false"
        class="range-input right"
        :class="{ 'range-input-wrap': showHandleWrap }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'

  interface Props {
    label?: string
    value?: [number | null, number | null]
    min?: number
    max?: number
    minPlaceholder?: string
    maxPlaceholder?: string
    showHandleWrap?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    label: '',
    value: () => [null, null],
    min: undefined,
    max: undefined,
    minPlaceholder: 'Min',
    maxPlaceholder: 'Max',
    showHandleWrap: true,
  })

  const emit = defineEmits(['update:value', 'change'])

  const minValue = ref<number | null>(props.value[0])
  const maxValue = ref<number | null>(props.value[1])

  // ✅ 防止父子更新死循环
  let isInnerUpdate = false

  // ✅ 外部 → 内部同步
  watch(
    () => props.value,
    (val) => {
      if (isInnerUpdate) return
      minValue.value = val?.[0] ?? null
      maxValue.value = val?.[1] ?? null
    },
    { deep: true },
  )

  // ✅ 内部 → 外部同步（核心：不做任何修正）
  watch([minValue, maxValue], ([min, max]) => {
    const val: [number | null, number | null] = [min, max]

    isInnerUpdate = true
    emit('update:value', val)
    emit('change', val)
    isInnerUpdate = false
  })
</script>

<style scoped>
  .range-inline {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    border: 1px solid #d9d9d9;
  }

  .range-inline:hover {
    border-color: #4096ff;
  }

  .range-label {
    font-size: 13px;
    color: #666;
    white-space: nowrap;
    padding: 0 4px;
  }

  .range-container {
    display: flex;
    align-items: center;
    overflow: hidden;
    transition: all 0.2s;
    flex: 1;
  }

  .range-container:focus-within {
    /* border-color: #4096ff; */
    /* box-shadow: 0 0 0 2px rgba(64, 150, 255, 0.2); */
  }

  .range-input {
    flex: 1;
  }

  .range-input :deep(.ant-input-number-input) {
    text-align: center;
    padding: 0;
  }

  .range-input :deep(.ant-input-number) {
    width: 100%;
    border: none;
    box-shadow: none;
  }

  .range-input-wrap :deep(.ant-input-number-handler-wrap) {
    display: none;
  }

  /* .range-input.left :deep(.ant-input-number) {
    border-right: 1px solid #f0f0f0;
  }

  .range-input.right :deep(.ant-input-number) {
    border-left: none;
  } */

  .divider {
    color: #999;
    font-size: 12px;
  }
</style>
